/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolDrawIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-draw"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.53 21.8Q3.98 21.8 3.59 21.41Q3.2 21.02 3.2 20.48L3.2 17.27Q3.2 16.75 3.4 16.26Q3.6 15.78 3.98 15.4L16.5 2.88Q16.85 2.52 17.29 2.36Q17.73 2.2 18.18 2.2Q18.63 2.2 19.05 2.36Q19.48 2.52 19.82 2.88L22.13 5.17Q22.48 5.53 22.64 5.95Q22.8 6.38 22.8 6.83Q22.8 7.28 22.64 7.71Q22.48 8.15 22.13 8.5L9.6 21.02Q9.22 21.4 8.74 21.6Q8.25 21.8 7.72 21.8ZM18.45 8.45L20.05 6.85L18.15 4.95L16.55 6.55ZM15.38 21.8Q17.32 21.8 19.01 20.79Q20.7 19.77 20.7 17.98Q20.7 17.07 20.21 16.39Q19.73 15.7 18.95 15.13Q18.5 14.78 17.96 14.76Q17.43 14.75 17.02 15.18Q16.63 15.6 16.63 16.18Q16.63 16.75 17.07 17.1Q17.5 17.4 17.77 17.59Q18.05 17.77 18.05 17.98Q18.05 18.43 17.24 18.79Q16.43 19.15 15.38 19.15Q14.82 19.15 14.44 19.54Q14.05 19.93 14.05 20.48Q14.05 21.02 14.44 21.41Q14.82 21.8 15.38 21.8ZM7.2 5.53Q7.2 5.72 6.85 5.99Q6.5 6.25 5.33 6.88Q3.48 7.88 2.84 8.64Q2.2 9.4 2.2 10.53Q2.2 11.15 2.42 11.66Q2.65 12.18 3.08 12.6Q3.48 12.97 4.03 12.97Q4.58 12.97 4.95 12.57Q5.33 12.18 5.33 11.65Q5.33 11.13 4.92 10.72Q4.88 10.68 4.86 10.63Q4.85 10.57 4.85 10.53Q4.85 10.32 5.15 10.13Q5.45 9.93 6.65 9.3Q8.6 8.28 9.22 7.45Q9.85 6.63 9.85 5.53Q9.85 4 8.82 3.1Q7.8 2.2 6.08 2.2Q5.05 2.2 4.21 2.6Q3.38 3 2.9 3.7Q2.6 4.15 2.64 4.67Q2.67 5.2 3.1 5.53Q3.52 5.85 4.06 5.84Q4.6 5.83 4.92 5.4Q5.13 5.13 5.39 4.99Q5.65 4.85 6.03 4.85Q6.6 4.85 6.9 5.05Q7.2 5.25 7.2 5.53Z" fill={color} />
    </svg>
  );
}
